import { AxiosInstance } from 'axios';

import BaseClient from './baseClient';
import { BaseDataResponse } from '../responses';
import { IErrorHandler } from '../abstractions';
import { RatingResponsePublicModel } from '../interfaces';

export default class RatingClient extends BaseClient {
  constructor(errorHandler: IErrorHandler, axiosInstance: AxiosInstance) {
    super(errorHandler, axiosInstance, 'rating');
  }

  public async getRatingsAsync(): Promise<BaseDataResponse<RatingResponsePublicModel>> {
    return this.getHttpAsync<BaseDataResponse<RatingResponsePublicModel>>('', '');
  }
}
